// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1___277e5892a00e03005fd{/*!*/}.FocusedNav-cls2___a4c31cf09194fd0785d{flex:0 1 auto;display:flex;justify-content:space-between;max-width:380px}.FocusedNav-cls2___a4c31cf09194fd0785d>*{margin:0 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1___277e5892a00e03005fd",
	"cls2": "FocusedNav-cls2___a4c31cf09194fd0785d FocusedNav-cls1___277e5892a00e03005fd"
};
export default ___CSS_LOADER_EXPORT___;
